/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
import React, { FC } from "react";
import { getContrastColor } from "../../../Library/Utils";
import useSecureImage from "../../../Hooks/useSecureImage";

interface IProfileImageProps {
  firstName?: string;
  lastName?: string;
  profileImage?: string;
  className?: string;
  backgroundColor?: string;
}

const ProfileImage: FC<IProfileImageProps> = ({
  firstName,
  lastName,
  profileImage,
  className,
  backgroundColor}) => {
  const imageSrc = useSecureImage(profileImage);
  return (
    <>
      <div>
        {imageSrc ? (
          <div className="user-avtar-img-section">
            <img
              src={imageSrc}
              alt="avtar"
              className={`user-avtar-img ${className}`}
            />
          </div>
        ) : (
          <div
            className={`user-initials ${className}`}
            style={{
              backgroundColor,
              color: getContrastColor(backgroundColor || "")}}
          >
            <h2 style={{ color: getContrastColor(backgroundColor || "") }}>
              {firstName?.charAt(0).toUpperCase() || ""}
              {lastName?.charAt(0).toUpperCase() || ""}
            </h2>
          </div>
        )}
      </div>
    </>
  );
};

export default ProfileImage;

ProfileImage.defaultProps = {
  firstName: "",
  lastName: "",
  profileImage: "",
  className: "list-user-avtar",
  backgroundColor: ""};
